module.exports = __webpack_public_path__ + "img/icon-dart.4f9fe5bf.png";